module.exports = __webpack_public_path__ + "static/media/Darumaka_gaussian2.e81d6ebe.png";